import React from 'react'
import { useScreenScheme } from '../../../Hooks/Features/TaskLayout/Screens/useScreenScheme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import _ from "underscore";
import CommanDialog from '../../CommonCompo/CommanDialog/CommanDialog';
import Configure from '../../../pages/Features/Tasks/Configure';

const ScreenSchemes = ({ filterValues, setFilterValues }) => {

    const { formValues, setFormValues, columns, rowData, loader, formFields, saveScreenSchemes, handleChange } = useScreenScheme({ filterValues, setFilterValues });

    return (
        <div>
            {!_.isEmpty(filterValues?.layout) ?
                <Configure filterValues={filterValues} setFilterValues={setFilterValues}/> :
                <div>
                    <div className='d-flex align-items-center gap-2 mb-2 w-100'>
                        <div style={{ flexGrow: 1 }}>
                            <input className='sk-input-dd mb-0' style={{ width: "100%" }} placeholder='Search Schemes...' value={formValues?.search} onChange={(e) => setFormValues((prev) => ({ ...prev, search: e?.target?.value }))} />
                        </div>
                        <button className='sk-btn sk-btn-primary bg-black text-white' style={{ whiteSpace: "nowrap" }} onClick={() => setFormValues((prev) => ({ ...prev, visible: true }))}><FontAwesomeIcon icon="fa-solid fa-plus" /> Add Screen Scheme</button>
                    </div>
                    <div style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
                        <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} headerHeight={40} rowHeight={"auto"} loader={loader?.grid} strippedTable={true} />
                    </div>
                </div>
            }

            <Dialog visible={formValues?.visible} onHide={() => setFormValues({ visible: false })} header={`${formValues?.isCopy ? "Copy" : !_.isEmpty(formValues?.editData) ? "Edit" : "Create"} Screen Scheme`} draggable={false} className='modal-medium'>
                <div className='row'>
                    {formFields?.map((item, index) => (
                        renderField(item, index, (e, is_edit) => { handleChange(item, e) }, formValues, {}, {}, () => { }, () => { })
                    ))}
                    <div className='w100 d-flex gap-1 justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setFormValues({ visible: false })}>Cancel</button>
                        {loader?.btn ? <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "125px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button>
                            : <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveScreenSchemes()}>Confirm Changes</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={formValues?.isDelete} handleClose={() => setFormValues({ visible: false })} handleFun={() => saveScreenSchemes()} message="Are you sure you want to delete this screen scheme?" />
        </div>
    )
}

export default ScreenSchemes